import type { Options } from 'services/content/components/props/types/Options'
import DropdownCountryCode from 'ui-component-library/components/00-Primitives/Inputs/DropdownCountryCode'
import DropdownStateProvince from 'ui-component-library/components/00-Primitives/Inputs/DropdownStateProvince'
import Dropdown from 'ui-component-library/components/00-Primitives/Inputs/Dropdown'

import style from './style.scss'

type Props = {
  field: 'course' | 'country' | 'stateProvince' | 'language'
  labelText: string
  placeholderText: string
  options?: Options
  onChange: (field: string, value: string) => void
  selectedCountry: string
  selectedOption?: string
}

function FindACourseFilter({
  field,
  placeholderText,
  labelText,
  onChange,
  selectedCountry,
  options,
  selectedOption,
}: Props) {
  function handleChange(value: string) {
    onChange(field, value)
  }

  switch (field) {
    case 'language':
    case 'course': {
      return (
        <Dropdown
          className={style.wrapper}
          options={options || []}
          label={labelText}
          handleOptionChange={handleChange}
          placeholder={placeholderText}
          inputId={field}
          selectedOption={selectedOption}
        />
      )
    }
    case 'country': {
      const handleChangeCountry = (field: string, value: string) => {
        onChange(field, value)
      }

      return (
        <DropdownCountryCode
          className={style.wrapper}
          label={labelText}
          handleChange={handleChangeCountry}
          inputId={field}
          placeholder={placeholderText}
          selectedOption={selectedOption}
        />
      )
    }
    case 'stateProvince':
      return (
        <DropdownStateProvince
          className={style.wrapper}
          label={labelText}
          handleChange={onChange}
          selectedCountry={selectedCountry}
          inputId={field}
          placeholder={placeholderText}
          selectedOption={selectedOption}
        />
      )
  }

  return null
}

export default FindACourseFilter
